import { reactive } from 'vue'
import { http } from './plugins/axios'

export const authState = reactive({ user: null, checked: false })
let checkPromise = null

export async function checkLogin() {
  if (authState.checked) return authState.user
  if (checkPromise) return checkPromise
  checkPromise = http.get('/api/auth/me').then(({ data }) => {
    authState.user = data
    return data
  }).catch(() => {
    authState.user = null
    return null
  }).finally(() => {
    authState.checked = true
    checkPromise = null
  })
  return checkPromise
}

export async function login(username, password) {
  const { data } = await http.post('/api/auth/login', { username, password })
  authState.user = data
  authState.checked = true
  return data
}

export async function changePassword(oldPassword, newPassword) {
  const { data } = await http.post('/api/auth/change-password', { oldPassword, newPassword })
  authState.user = data
  return data
}

export async function logout() {
  try {
    await http.post('/api/auth/logout')
  } finally {
    authState.user = null
    authState.checked = true
  }
}

export function authErrorMessage(error, fallback) {
  return error.response?.data?.message || (error.response?.status === 429
    ? '操作过于频繁，请稍后再试' : fallback)
}
